import { FC, useCallback, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import NotificationsIcon from 'mdi-react/NotificationsIcon';
import classNames from 'classnames';

const Notifications = dynamic(
  () => import(/* webpackChunkName: "Notifications" */ 'modules/users/components/Notifications')
);
import { hasUnreadNotificationsSelector } from 'modules/users/duck';
import { useClickOutsideElement } from 'src/hooks';

import styles from './NotificationContainer.module.scss';

const NotificationContainer: FC = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const hasUnread = useSelector(hasUnreadNotificationsSelector);
  const container = useRef<HTMLDivElement>(null);

  const handleToggle = useCallback(() => {
    setIsOpen((value) => !value);
  }, []);
  useClickOutsideElement(container, handleToggle, isOpen);

  return (
    <div className={styles.container} ref={container}>
      <button
        className={classNames(styles.button, { [styles.open]: isOpen, [styles.unread]: hasUnread })}
        onClick={handleToggle}
      >
        <NotificationsIcon />
      </button>
      {isOpen && (
        <div className={styles.popup}>
          <Notifications language={language} />
        </div>
      )}
    </div>
  );
};

export default NotificationContainer;
